import _ from 'lodash';
import { isEmptyOrNull } from 'shared/utils/isEmptyOrNull';
import { PRICE_SELECTED, QUOTED } from 'shared/data/quoteSteps';
import defaultState from 'us_quickturn_prototype_pcb/pcb_fabrication/data/defaultState';

const state = _.cloneDeep(defaultState);

if (Spree.productToCompare) {
  state.productToCompare = Spree.productToCompare;
}

if (Spree.fabrication) {
  const { quote, quote_parameters } = Spree.fabrication;
  state.quantitiesChanged = true;
  state.lineItemId = Spree.fabrication.line_item_id;
  state.quote = quote;

  if (quote_parameters) {
    state.parameters = _.assign({}, state.parameters, quote_parameters);
  }

  state.quoteStep = isEmptyOrNull(state.parameters.row_selected) ||
                    isEmptyOrNull(state.parameters.column_selected) ? QUOTED : PRICE_SELECTED;
} else if (Spree.assembly) {
  // If the project does not include fabrication, but includes assembly take parameters from assembly
  const { part_number, revision, filename } = Spree.assembly.quote_parameters;

  state.parameters.part_number = part_number;
  state.parameters.revision = revision;
  state.parameters.filename = filename;
} else if (Spree.stencils && Spree.stencils.length > 0) {
  // If the project does not include fabrication, but includes stencils take parameters from stencils
  const { parameters: stencilParameters } = Spree.stencils[0];
  let { part_number } = stencilParameters;
  const { revision, filename } = stencilParameters;

  if (part_number.endsWith('-Top Side')) {
    part_number = part_number.replace('-Top Side', '');
  } else if (part_number.endsWith('-Bottom Side')) {
    part_number = part_number.replace('-Bottom Side', '');
  } else if (part_number.endsWith('-Combine Top & Bottom')) {
    part_number = part_number.replace('-Combine Top & Bottom', '');
  }

  if (!state.parameters.part_number) {
    state.parameters.part_number = part_number;
  }

  if (!state.parameters.revision) {
    state.parameters.revision = revision;
  }

  if (!state.parameters.filename) {
    state.parameters.filename = filename;
  }
} else if (Spree.parts) {
  // If the project does not include fabrication, but includes parts take parameters from parts
  const { part_number, revision, zip_file } = Spree.parts;
  state.parameters.part_number = part_number;
  state.parameters.revision = revision;
  state.parameters.filename = zip_file;
}

if (Spree.currentVariant) {
  state.currentVariant = Spree.currentVariant;
}

if (Spree.currentUserEmail) {
  state.parameters.email_address = Spree.currentUserEmail;
} else {
  state.parameters.email_address = 'support@pentalogix.com';
}

export default state;
